import { ofType } from 'redux-observable'
import { switchMap, map } from 'rxjs/operators'
import { ajax as utlAjax } from 'Utils'
import environment from 'environments/environment'
import { Apis } from 'Redux/APIs'
import { CLINIC_LIST, SWITCH_CLINIC } from './clinic.types'
import { clinicListResponse, switchClinicResponse } from './clinic.actions'

const { baseUrl } = environment
const clinicEpic = {}

clinicEpic.clinicList = (action$) =>
  action$.pipe(
    ofType(CLINIC_LIST),
    switchMap((action) =>
      utlAjax({
        url: `${baseUrl}/${Apis.Clinic_list}`,
        method: 'GET',
        // body: action.payload,
      }).pipe(
        map(
          (response) => clinicListResponse(response),
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
clinicEpic.switchClinic = (action$) =>
  action$.pipe(
    ofType(SWITCH_CLINIC),
    switchMap((action) =>
      utlAjax({
        url: `${baseUrl}/${Apis.Switch_Clinic}`,
        method: 'POST',
        body: action.payload,
      }).pipe(
        map(
          (response) => switchClinicResponse(response),
          // takeUntil(action$.pipe(ofType(REQUEST_CANCEL))),
        ),
      ),
    ),
  )
export default clinicEpic
